import { Configuration, ArtrackTracksApi, ArtrackWaypointsApi } from '../../sdk';

const SDK_BASE_URL = (import.meta as any).env?.VITE_SDK_BASE_URL || (typeof window !== 'undefined' ? window.location.origin : '');

const sdkConfig = new Configuration({ basePath: SDK_BASE_URL });

export interface TrackInfo {
  id: number;
  name: string;
  description?: string;
}

export interface WaypointMedia {
  url?: string | null;
  thumbnailUrl?: string | null;
  type?: string | null;
  storageObjectId?: number | null;
}

export interface WaypointDetail {
  id: number;
  latitude: number;
  longitude: number;
  altitude?: number | null;
  recordedAt?: string;
  userDescription?: string | null;
  media: WaypointMedia[];
}

export const trackAdapter = {
  async listTracks(limit = 20, offset = 0, visibility?: string): Promise<{ items: Array<{ id: number; name: string }> }> {
    const api = new ArtrackTracksApi(sdkConfig);
    const res = await api.listTracksArtrackTracksGet(visibility as any, limit, offset, undefined);
    const data: any = res.data;
    // Normalize: some APIs return {items: [...]}, others return array
    const itemsRaw = Array.isArray(data) ? data : (data?.items || []);
    const items = itemsRaw.map((t: any) => ({ id: Number(t.id), name: String(t.name || `Track #${t.id}`) }));
    return { items };
  },

  async getTrack(trackId: number): Promise<TrackInfo> {
    const api = new ArtrackTracksApi(sdkConfig);
    const res = await api.getTrackArtrackTracksTrackIdGet(trackId, undefined);
    return { id: res.data.id, name: res.data.name, description: (res.data as any).description } as TrackInfo;
  },

  async listWaypointsDetail(trackId: number): Promise<WaypointDetail[]> {
    const api = new ArtrackWaypointsApi(sdkConfig);
    // segment_id left undefined; use limit=500, offset=0
    const res = await api.listWaypointsDetailArtrackTracksTrackIdWaypointsDetailGet(trackId, undefined as any, 500, 0, undefined);
    const items = res.data as any[];
    return items.map((w: any) => ({
      id: w.id,
      latitude: w.latitude,
      longitude: w.longitude,
      altitude: w.altitude ?? null,
      recordedAt: w.recorded_at,
      userDescription: w.user_description ?? null,
      media: Array.isArray(w.media) ? w.media.map((m: any) => ({ url: m.url, thumbnailUrl: m.thumbnail_url, type: m.type, storageObjectId: m.storage_object_id })) : []
    }));
  }
};
